import { useEffect, useState } from "react";
import { getAPIURL } from "../../../services/helper";
import http from "../../../services/http";
import { Spinner, Table } from "reactstrap";
import ReportPrintHeader from "../components/ReportPrintHeader";
import { useParams } from "react-router-dom";

const EODSummaryPrint = () => {
  const { register_id } = useParams();
  const api_url = getAPIURL();
  const [register, setRegister] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    if (!loading) {
      setTimeout(() => window.print(), 500);
    }
  }, [loading]);

  const fetchReport = async () => {
    try {
      const { data } = await http.get(
        `${api_url}/reports/close/detail/${register_id}`
      );
      setRegister(data);
      setTransactions(data.transactions || []);
    } catch (err) {
      console.error("Print load error", err);
    }
    setLoading(false);
  };

  const paymentSummary = transactions.reduce((acc, t) => {
    const type = t.payment_type || "Unknown";
    acc[type] = acc[type] || { count: 0, amount: 0 };
    acc[type].count += 1;
    acc[type].amount += parseFloat(t.order_total || 0);
    return acc;
  }, {});

  const total = {
    orders: transactions.length,
    discount: transactions.reduce((s, t) => s + parseFloat(t.discount || 0), 0),
    tax: transactions.reduce((s, t) => s + parseFloat(t.tax_collected || 0), 0),
    total: transactions.reduce((s, t) => s + parseFloat(t.order_total || 0), 0),
  };

  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner color="primary" size="lg" />
        <p>Preparing report...</p>
      </div>
    );
  }

  if (!register) {
    return <div className="text-center mt-4">No data found</div>;
  }

  return (
    <div className="page-body">
      <ReportPrintHeader title="End of Day Summary" />

      <h5>EOD#: {register.station_close_number}</h5>
      <p>Closed At: {register.closed_at}</p>

      <h6 className="mt-4">Payment Summary</h6>
      <Table bordered size="sm">
        <thead>
          <tr>
            <th>Payment Type</th>
            <th>Count</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(paymentSummary).map(([type, val]) => (
            <tr key={type}>
              <td>{type}</td>
              <td>{val.count}</td>
              <td>${val.amount.toFixed(2)}</td>
            </tr>
          ))}
          <tr>
            <td>
              <strong>Total</strong>
            </td>
            <td>
              <strong>{total.orders}</strong>
            </td>
            <td>
              <strong>${total.total.toFixed(2)}</strong>
            </td>
          </tr>
        </tbody>
      </Table>

      <h6 className="mt-4">Sales Breakdown</h6>
      <Table bordered size="sm">
        <tbody>
          <tr>
            <td>Sales (incl. tax)</td>
            <td>${total.total.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Total Tax</td>
            <td>${total.tax.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Discount Given</td>
            <td>${total.discount.toFixed(2)}</td>
          </tr>
          <tr>
            <td>Orders</td>
            <td>{total.orders}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default EODSummaryPrint;
